import { useFormContext } from 'react-hook-form'
import { Radio } from '@mui/material'

import { DefaultElementProps } from 'common/interfaces'
import { switchersStyle, switcherWithSubheadingPrivateSwitchBase } from 'common/styles'
import FormControlLabel from 'components/FormControlLabel'
import FormControlLabelInner from 'components/FormControlLabelInner'
import RadioGroupWrapper from 'components/RadioGroupWrapper'

import { RadioGroup as RadioGroupProps, RadioGroupOption } from './interface'

function radioOptions(options: RadioGroupOption[]): JSX.Element[] {
  return options.map(({ value, label, subheading }) => (
    <FormControlLabel
      key={value}
      value={value}
      label={<FormControlLabelInner label={label} subheading={subheading} />}
      control={<Radio sx={switchersStyle} />}
      sx={subheading !== undefined ? switcherWithSubheadingPrivateSwitchBase : {}}
    />
  ))
}

export default function RadioGroup({
  name,
  size,
  label,
  options,
  onFocus,
  onChange,
  direction,
  defaultValue,
  validations,
}: RadioGroupProps & DefaultElementProps): JSX.Element {
  const { control } = useFormContext()

  return (
    <RadioGroupWrapper
      classNames="radio-wrap"
      control={control}
      onFocus={onFocus}
      onChange={onChange}
      name={name}
      validations={validations}
      size={size}
      label={label}
      direction={direction}
      defaultValue={defaultValue}
    >
      {radioOptions(options)}
    </RadioGroupWrapper>
  )
}
